import React, { Fragment } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Home from './components/Home'
import Footer from './components/Footer'
import Experiences from './components/Experiences'
import Informations from './components/Informations'
import Kayahara from './components/experiences/Kayahara/Kayahara'
import EmotionsPerformancesTasks from './components/experiences/EmotionsPerformances/EPTasks'
import EmotionsPerformancesResults from './components/experiences/EmotionsPerformances/EPResults'
import DonePage from './components/experiences/EmotionsPerformances/DonePage'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import './App.css';
import './App.scss';

//225	106	68	

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#777'
    },
    secondary: {
      main: '#e16a44'
    }
  }
});

//Navigations Tabs
// const sections = [
//   { title: 'Accueil', url: '/' },
//   { title: 'Experiences', url: '/experience/EmotionsPerformancesscreen' },
//   { title: 'Informations', url: '/informations' },
// ];
  
function App() {

  return (
    <MuiThemeProvider theme={theme}>
    <div className='container'>
      {/* <Header /> */}
      <div className='App'>
         <Router >
          {/* Définition de toutes les routes avec un redirect si URL inconnu Gab : EmotionsPerformancesTasks*/}
            <Switch>
              <Route exact path='/' component={Home}/>
              <Route
                exact
                path='/experiences'
                render={(props)=>
                  <Fragment>                
                    <Experiences />                  
                  </Fragment>}/>
              <Route
                exact
                path='/informations'
                render={(props)=>
                  <Fragment>              
                    <Informations />                
                  </Fragment>}/>
              <Route
                exact
                path='/experience/kayahara'
                render={(props)=>
                  <Fragment>                
                    <Kayahara/>                  
                  </Fragment>}/>
              {/* <Route
                exact
                path='/experience/EmotionsPerformancesscreen'
                render={(props)=>
                  <Fragment>                
                    <EmotionsPerformancesScreen />                  
                  </Fragment>}/> */}
              <Route
                exact
                path='/experience/EmotionsPerformances'
                render={(props)=>
                  <Fragment>                
                    <EmotionsPerformancesTasks/>                  
                  </Fragment>}/>
              <Route
                exact
                path='/experience/EmotionsPerformancesresults'
                render={(props)=>
                  <Fragment>                
                    <EmotionsPerformancesResults/>                  
                  </Fragment>}/>
              <Route
                exact
                path='/experience/end'
                render={(props)=>
                  <Fragment>                
                    <DonePage/>                  
                  </Fragment>}/>
              <Redirect to="/" /> 
            </Switch>
          </Router>
        </div>
        <Footer className="footer" title="ULaval Experiences" description="julien.bureau@fse.ulaval.ca" />
      </div>
      </MuiThemeProvider>
  )};

export default App;